<ckeditor #ckEditorInstance [(data)]="content" [editorUrl]="ckeditorUrl" [config]="config"></ckeditor>